/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { ActionRemove24 } from './ActionRemove24'
import { ActionsAlerts32 } from './ActionsAlerts32'
import { Alert12 } from './Alert12'
import { Alert16 } from './Alert16'
import { Alert24 } from './Alert24'
import { AlertFilled16 } from './AlertFilled16'
import { AlertFilled24 } from './AlertFilled24'
import { ArrowDown12 } from './ArrowDown12'
import { ArrowDown16 } from './ArrowDown16'
import { ArrowDown24 } from './ArrowDown24'
import { ArrowDownFill12 } from './ArrowDownFill12'
import { ArrowDownFill16 } from './ArrowDownFill16'
import { ArrowDownFill24 } from './ArrowDownFill24'
import { ArrowLeft12 } from './ArrowLeft12'
import { ArrowLeft16 } from './ArrowLeft16'
import { ArrowLeft24 } from './ArrowLeft24'
import { ArrowLeftFill12 } from './ArrowLeftFill12'
import { ArrowLeftFill16 } from './ArrowLeftFill16'
import { ArrowLeftFill24 } from './ArrowLeftFill24'
import { ArrowRight12 } from './ArrowRight12'
import { ArrowRight16 } from './ArrowRight16'
import { ArrowRight24 } from './ArrowRight24'
import { ArrowRightFill12 } from './ArrowRightFill12'
import { ArrowRightFill16 } from './ArrowRightFill16'
import { ArrowRightFill24 } from './ArrowRightFill24'
import { ArrowUp12 } from './ArrowUp12'
import { ArrowUp16 } from './ArrowUp16'
import { ArrowUp24 } from './ArrowUp24'
import { ArrowUpFill12 } from './ArrowUpFill12'
import { ArrowUpFill16 } from './ArrowUpFill16'
import { ArrowUpFill24 } from './ArrowUpFill24'
import { BubbleChecked12 } from './BubbleChecked12'
import { BubbleChecked16 } from './BubbleChecked16'
import { BubbleChecked24 } from './BubbleChecked24'
import { BubbleDot24 } from './BubbleDot24'
import { BubbleEmpty24 } from './BubbleEmpty24'
import { BubblePause24 } from './BubblePause24'
import { BubblePlus16 } from './BubblePlus16'
import { BubblePlus24 } from './BubblePlus24'
import { BubbleRadioButton24 } from './BubbleRadioButton24'
import { BubbleRemove16 } from './BubbleRemove16'
import { BubbleRemove24 } from './BubbleRemove24'
import { BubbleRemoveFilled16 } from './BubbleRemoveFilled16'
import { BubbleRemoveFilled24 } from './BubbleRemoveFilled24'
import { CaretDown12 } from './CaretDown12'
import { CaretDown16 } from './CaretDown16'
import { CaretDown24 } from './CaretDown24'
import { CaretLeft12 } from './CaretLeft12'
import { CaretLeft16 } from './CaretLeft16'
import { CaretLeft24 } from './CaretLeft24'
import { CaretRight12 } from './CaretRight12'
import { CaretRight16 } from './CaretRight16'
import { CaretRight24 } from './CaretRight24'
import { CaretUp12 } from './CaretUp12'
import { CaretUp16 } from './CaretUp16'
import { CaretUp24 } from './CaretUp24'
import { CheckboxEmpty16 } from './CheckboxEmpty16'
import { CheckboxEmpty24 } from './CheckboxEmpty24'
import { CheckboxFilled16 } from './CheckboxFilled16'
import { CheckboxFilled24 } from './CheckboxFilled24'
import { Checkmark12 } from './Checkmark12'
import { Checkmark16 } from './Checkmark16'
import { Checkmark24 } from './Checkmark24'
import { Close12 } from './Close12'
import { Close16 } from './Close16'
import { Close24 } from './Close24'
import { Copy12 } from './Copy12'
import { Copy16 } from './Copy16'
import { Copy24 } from './Copy24'
import { Disclosures24 } from './Disclosures24'
import { Documents24 } from './Documents24'
import { Dot12 } from './Dot12'
import { Dot16 } from './Dot16'
import { Dot24 } from './Dot24'
import { Dots16 } from './Dots16'
import { Dots24 } from './Dots24'
import { Dropdown12 } from './Dropdown12'
import { Dropdown16 } from './Dropdown16'
import { Dropdown24 } from './Dropdown24'
import { Energy12 } from './Energy12'
import { Energy24 } from './Energy24'
import { Hamburger12 } from './Hamburger12'
import { Hamburger16 } from './Hamburger16'
import { Hamburger24 } from './Hamburger24'
import { Help24 } from './Help24'
import { History16 } from './History16'
import { History24 } from './History24'
import { Info12 } from './Info12'
import { Info16 } from './Info16'
import { Info24 } from './Info24'
import { InfoFilled12 } from './InfoFilled12'
import { InfoFilled16 } from './InfoFilled16'
import { InfoFilled24 } from './InfoFilled24'
import { Link16 } from './Link16'
import { Link24 } from './Link24'
import { LinkOut12 } from './LinkOut12'
import { LinkOut16 } from './LinkOut16'
import { LinkOut24 } from './LinkOut24'
import { Lock12 } from './Lock12'
import { Lock16 } from './Lock16'
import { Lock24 } from './Lock24'
import { LogOut24 } from './LogOut24'
import { MessageSend16 } from './MessageSend16'
import { MessageSend24 } from './MessageSend24'
import { Minus12 } from './Minus12'
import { Minus16 } from './Minus16'
import { Minus24 } from './Minus24'
import { Notification16 } from './Notification16'
import { Notification24 } from './Notification24'
import { Notification32 } from './Notification32'
import { Order16 } from './Order16'
import { Order24 } from './Order24'
import { Person12 } from './Person12'
import { Person16 } from './Person16'
import { Person24 } from './Person24'
import { PhoneConnected16 } from './PhoneConnected16'
import { PlayInline16 } from './PlayInline16'
import { PlayInline24 } from './PlayInline24'
import { Plus12 } from './Plus12'
import { Plus16 } from './Plus16'
import { Plus24 } from './Plus24'
import { PopOut16 } from './PopOut16'
import { PopOut24 } from './PopOut24'
import { Question12 } from './Question12'
import { Question16 } from './Question16'
import { Question24 } from './Question24'
import { QuestionFilled12 } from './QuestionFilled12'
import { QuestionFilled16 } from './QuestionFilled16'
import { QuestionFilled24 } from './QuestionFilled24'
import { Recurring12 } from './Recurring12'
import { Recurring16 } from './Recurring16'
import { Recurring24 } from './Recurring24'
import { Repeat16 } from './Repeat16'
import { Robinhood16 } from './Robinhood16'
import { Robinhood24 } from './Robinhood24'
import { Search16 } from './Search16'
import { Search24 } from './Search24'
import { Settings12 } from './Settings12'
import { Settings16 } from './Settings16'
import { Settings24 } from './Settings24'
import { StarFilled12 } from './StarFilled12'
import { StarFilled16 } from './StarFilled16'
import { StarFilled24 } from './StarFilled24'
import { ThumbsDown16 } from './ThumbsDown16'
import { ThumbsDown24 } from './ThumbsDown24'
import { ThumbsUp16 } from './ThumbsUp16'
import { ThumbsUp24 } from './ThumbsUp24'
import { Transfers16 } from './Transfers16'
import { Transfers24 } from './Transfers24'
import { Trash12 } from './Trash12'
import { Trash16 } from './Trash16'
import { Trash24 } from './Trash24'
import { TriangleAlert16 } from './TriangleAlert16'
import { TriangleAlert24 } from './TriangleAlert24'

export * from './directory'

export const CoreIcons = {
  ActionRemove24,
  ActionsAlerts32,
  Alert12,
  Alert16,
  Alert24,
  AlertFilled16,
  AlertFilled24,
  ArrowDown12,
  ArrowDown16,
  ArrowDown24,
  ArrowDownFill12,
  ArrowDownFill16,
  ArrowDownFill24,
  ArrowLeft12,
  ArrowLeft16,
  ArrowLeft24,
  ArrowLeftFill12,
  ArrowLeftFill16,
  ArrowLeftFill24,
  ArrowRight12,
  ArrowRight16,
  ArrowRight24,
  ArrowRightFill12,
  ArrowRightFill16,
  ArrowRightFill24,
  ArrowUp12,
  ArrowUp16,
  ArrowUp24,
  ArrowUpFill12,
  ArrowUpFill16,
  ArrowUpFill24,
  BubbleChecked12,
  BubbleChecked16,
  BubbleChecked24,
  BubbleDot24,
  BubbleEmpty24,
  BubblePause24,
  BubblePlus16,
  BubblePlus24,
  BubbleRadioButton24,
  BubbleRemove16,
  BubbleRemove24,
  BubbleRemoveFilled16,
  BubbleRemoveFilled24,
  CaretDown12,
  CaretDown16,
  CaretDown24,
  CaretLeft12,
  CaretLeft16,
  CaretLeft24,
  CaretRight12,
  CaretRight16,
  CaretRight24,
  CaretUp12,
  CaretUp16,
  CaretUp24,
  CheckboxEmpty16,
  CheckboxEmpty24,
  CheckboxFilled16,
  CheckboxFilled24,
  Checkmark12,
  Checkmark16,
  Checkmark24,
  Close12,
  Close16,
  Close24,
  Copy12,
  Copy16,
  Copy24,
  Disclosures24,
  Documents24,
  Dot12,
  Dot16,
  Dot24,
  Dots16,
  Dots24,
  Dropdown12,
  Dropdown16,
  Dropdown24,
  Energy12,
  Energy24,
  Hamburger12,
  Hamburger16,
  Hamburger24,
  Help24,
  History16,
  History24,
  Info12,
  Info16,
  Info24,
  InfoFilled12,
  InfoFilled16,
  InfoFilled24,
  Link16,
  Link24,
  LinkOut12,
  LinkOut16,
  LinkOut24,
  Lock12,
  Lock16,
  Lock24,
  LogOut24,
  MessageSend16,
  MessageSend24,
  Minus12,
  Minus16,
  Minus24,
  Notification16,
  Notification24,
  Notification32,
  Order16,
  Order24,
  Person12,
  Person16,
  Person24,
  PhoneConnected16,
  PlayInline16,
  PlayInline24,
  Plus12,
  Plus16,
  Plus24,
  PopOut16,
  PopOut24,
  Question12,
  Question16,
  Question24,
  QuestionFilled12,
  QuestionFilled16,
  QuestionFilled24,
  Recurring12,
  Recurring16,
  Recurring24,
  Repeat16,
  Robinhood16,
  Robinhood24,
  Search16,
  Search24,
  Settings12,
  Settings16,
  Settings24,
  StarFilled12,
  StarFilled16,
  StarFilled24,
  ThumbsDown16,
  ThumbsDown24,
  ThumbsUp16,
  ThumbsUp24,
  Transfers16,
  Transfers24,
  Trash12,
  Trash16,
  Trash24,
  TriangleAlert16,
  TriangleAlert24,
}

export const LazyIcons = {
  AccountSummary12: React.lazy(() =>
    import('./AccountSummary12').then(({ AccountSummary12 }) => ({
      default: AccountSummary12,
    }))
  ),
  AccountSummary24: React.lazy(() =>
    import('./AccountSummary24').then(({ AccountSummary24 }) => ({
      default: AccountSummary24,
    }))
  ),
  ActionsAtm32: React.lazy(() =>
    import('./ActionsAtm32').then(({ ActionsAtm32 }) => ({
      default: ActionsAtm32,
    }))
  ),
  ActionsCheck32: React.lazy(() =>
    import('./ActionsCheck32').then(({ ActionsCheck32 }) => ({
      default: ActionsCheck32,
    }))
  ),
  ActionsStatements32: React.lazy(() =>
    import('./ActionsStatements32').then(({ ActionsStatements32 }) => ({
      default: ActionsStatements32,
    }))
  ),
  ActionsTransfers32: React.lazy(() =>
    import('./ActionsTransfers32').then(({ ActionsTransfers32 }) => ({
      default: ActionsTransfers32,
    }))
  ),
  Agent16: React.lazy(() =>
    import('./Agent16').then(({ Agent16 }) => ({
      default: Agent16,
    }))
  ),
  Agent24: React.lazy(() =>
    import('./Agent24').then(({ Agent24 }) => ({
      default: Agent24,
    }))
  ),
  AllDayTrading12: React.lazy(() =>
    import('./AllDayTrading12').then(({ AllDayTrading12 }) => ({
      default: AllDayTrading12,
    }))
  ),
  AllDayTrading16: React.lazy(() =>
    import('./AllDayTrading16').then(({ AllDayTrading16 }) => ({
      default: AllDayTrading16,
    }))
  ),
  AllDayTrading24: React.lazy(() =>
    import('./AllDayTrading24').then(({ AllDayTrading24 }) => ({
      default: AllDayTrading24,
    }))
  ),
  Announcement16: React.lazy(() =>
    import('./Announcement16').then(({ Announcement16 }) => ({
      default: Announcement16,
    }))
  ),
  Announcement24: React.lazy(() =>
    import('./Announcement24').then(({ Announcement24 }) => ({
      default: Announcement24,
    }))
  ),
  Archive24: React.lazy(() =>
    import('./Archive24').then(({ Archive24 }) => ({
      default: Archive24,
    }))
  ),
  Attach24: React.lazy(() =>
    import('./Attach24').then(({ Attach24 }) => ({
      default: Attach24,
    }))
  ),
  Backspace24: React.lazy(() =>
    import('./Backspace24').then(({ Backspace24 }) => ({
      default: Backspace24,
    }))
  ),
  Backspace32: React.lazy(() =>
    import('./Backspace32').then(({ Backspace32 }) => ({
      default: Backspace32,
    }))
  ),
  Banking16: React.lazy(() =>
    import('./Banking16').then(({ Banking16 }) => ({
      default: Banking16,
    }))
  ),
  Banking24: React.lazy(() =>
    import('./Banking24').then(({ Banking24 }) => ({
      default: Banking24,
    }))
  ),
  Banking32: React.lazy(() =>
    import('./Banking32').then(({ Banking32 }) => ({
      default: Banking32,
    }))
  ),
  BubblePlusFilled24: React.lazy(() =>
    import('./BubblePlusFilled24').then(({ BubblePlusFilled24 }) => ({
      default: BubblePlusFilled24,
    }))
  ),
  BubbleReverse24: React.lazy(() =>
    import('./BubbleReverse24').then(({ BubbleReverse24 }) => ({
      default: BubbleReverse24,
    }))
  ),
  BubbleUkPounds16: React.lazy(() =>
    import('./BubbleUkPounds16').then(({ BubbleUkPounds16 }) => ({
      default: BubbleUkPounds16,
    }))
  ),
  BubbleUkPounds24: React.lazy(() =>
    import('./BubbleUkPounds24').then(({ BubbleUkPounds24 }) => ({
      default: BubbleUkPounds24,
    }))
  ),
  BubbleUkPoundsFilled16: React.lazy(() =>
    import('./BubbleUkPoundsFilled16').then(({ BubbleUkPoundsFilled16 }) => ({
      default: BubbleUkPoundsFilled16,
    }))
  ),
  BubbleUkPoundsFilled24: React.lazy(() =>
    import('./BubbleUkPoundsFilled24').then(({ BubbleUkPoundsFilled24 }) => ({
      default: BubbleUkPoundsFilled24,
    }))
  ),
  Builder16: React.lazy(() =>
    import('./Builder16').then(({ Builder16 }) => ({
      default: Builder16,
    }))
  ),
  Builder24: React.lazy(() =>
    import('./Builder24').then(({ Builder24 }) => ({
      default: Builder24,
    }))
  ),
  Calendar16: React.lazy(() =>
    import('./Calendar16').then(({ Calendar16 }) => ({
      default: Calendar16,
    }))
  ),
  Calendar24: React.lazy(() =>
    import('./Calendar24').then(({ Calendar24 }) => ({
      default: Calendar24,
    }))
  ),
  Camera16: React.lazy(() =>
    import('./Camera16').then(({ Camera16 }) => ({
      default: Camera16,
    }))
  ),
  Camera24: React.lazy(() =>
    import('./Camera24').then(({ Camera24 }) => ({
      default: Camera24,
    }))
  ),
  Cash24: React.lazy(() =>
    import('./Cash24').then(({ Cash24 }) => ({
      default: Cash24,
    }))
  ),
  Chart24: React.lazy(() =>
    import('./Chart24').then(({ Chart24 }) => ({
      default: Chart24,
    }))
  ),
  ChartCandlesticks16: React.lazy(() =>
    import('./ChartCandlesticks16').then(({ ChartCandlesticks16 }) => ({
      default: ChartCandlesticks16,
    }))
  ),
  ChartCandlesticks24: React.lazy(() =>
    import('./ChartCandlesticks24').then(({ ChartCandlesticks24 }) => ({
      default: ChartCandlesticks24,
    }))
  ),
  ChartLine16: React.lazy(() =>
    import('./ChartLine16').then(({ ChartLine16 }) => ({
      default: ChartLine16,
    }))
  ),
  ChartLine24: React.lazy(() =>
    import('./ChartLine24').then(({ ChartLine24 }) => ({
      default: ChartLine24,
    }))
  ),
  Chat16: React.lazy(() =>
    import('./Chat16').then(({ Chat16 }) => ({
      default: Chat16,
    }))
  ),
  Chat24: React.lazy(() =>
    import('./Chat24').then(({ Chat24 }) => ({
      default: Chat24,
    }))
  ),
  Chatbot16: React.lazy(() =>
    import('./Chatbot16').then(({ Chatbot16 }) => ({
      default: Chatbot16,
    }))
  ),
  Chatbot24: React.lazy(() =>
    import('./Chatbot24').then(({ Chatbot24 }) => ({
      default: Chatbot24,
    }))
  ),
  Clipboard16: React.lazy(() =>
    import('./Clipboard16').then(({ Clipboard16 }) => ({
      default: Clipboard16,
    }))
  ),
  Clipboard24: React.lazy(() =>
    import('./Clipboard24').then(({ Clipboard24 }) => ({
      default: Clipboard24,
    }))
  ),
  Clock16: React.lazy(() =>
    import('./Clock16').then(({ Clock16 }) => ({
      default: Clock16,
    }))
  ),
  Clock24: React.lazy(() =>
    import('./Clock24').then(({ Clock24 }) => ({
      default: Clock24,
    }))
  ),
  Cloud16: React.lazy(() =>
    import('./Cloud16').then(({ Cloud16 }) => ({
      default: Cloud16,
    }))
  ),
  Cloud24: React.lazy(() =>
    import('./Cloud24').then(({ Cloud24 }) => ({
      default: Cloud24,
    }))
  ),
  Collapse16: React.lazy(() =>
    import('./Collapse16').then(({ Collapse16 }) => ({
      default: Collapse16,
    }))
  ),
  Collapse24: React.lazy(() =>
    import('./Collapse24').then(({ Collapse24 }) => ({
      default: Collapse24,
    }))
  ),
  ConsumerGoods12: React.lazy(() =>
    import('./ConsumerGoods12').then(({ ConsumerGoods12 }) => ({
      default: ConsumerGoods12,
    }))
  ),
  ConsumerGoods16: React.lazy(() =>
    import('./ConsumerGoods16').then(({ ConsumerGoods16 }) => ({
      default: ConsumerGoods16,
    }))
  ),
  ConsumerGoods24: React.lazy(() =>
    import('./ConsumerGoods24').then(({ ConsumerGoods24 }) => ({
      default: ConsumerGoods24,
    }))
  ),
  Controls16: React.lazy(() =>
    import('./Controls16').then(({ Controls16 }) => ({
      default: Controls16,
    }))
  ),
  Controls24: React.lazy(() =>
    import('./Controls24').then(({ Controls24 }) => ({
      default: Controls24,
    }))
  ),
  Conversation16: React.lazy(() =>
    import('./Conversation16').then(({ Conversation16 }) => ({
      default: Conversation16,
    }))
  ),
  Conversation24: React.lazy(() =>
    import('./Conversation24').then(({ Conversation24 }) => ({
      default: Conversation24,
    }))
  ),
  Corporate16: React.lazy(() =>
    import('./Corporate16').then(({ Corporate16 }) => ({
      default: Corporate16,
    }))
  ),
  Corporate24: React.lazy(() =>
    import('./Corporate24').then(({ Corporate24 }) => ({
      default: Corporate24,
    }))
  ),
  Crypto12: React.lazy(() =>
    import('./Crypto12').then(({ Crypto12 }) => ({
      default: Crypto12,
    }))
  ),
  Crypto24: React.lazy(() =>
    import('./Crypto24').then(({ Crypto24 }) => ({
      default: Crypto24,
    }))
  ),
  CryptoC24: React.lazy(() =>
    import('./CryptoC24').then(({ CryptoC24 }) => ({
      default: CryptoC24,
    }))
  ),
  Deposit24: React.lazy(() =>
    import('./Deposit24').then(({ Deposit24 }) => ({
      default: Deposit24,
    }))
  ),
  Dining24: React.lazy(() =>
    import('./Dining24').then(({ Dining24 }) => ({
      default: Dining24,
    }))
  ),
  Dividend16: React.lazy(() =>
    import('./Dividend16').then(({ Dividend16 }) => ({
      default: Dividend16,
    }))
  ),
  Dividend24: React.lazy(() =>
    import('./Dividend24').then(({ Dividend24 }) => ({
      default: Dividend24,
    }))
  ),
  DollarSign12: React.lazy(() =>
    import('./DollarSign12').then(({ DollarSign12 }) => ({
      default: DollarSign12,
    }))
  ),
  DollarSign16: React.lazy(() =>
    import('./DollarSign16').then(({ DollarSign16 }) => ({
      default: DollarSign16,
    }))
  ),
  DollarSign24: React.lazy(() =>
    import('./DollarSign24').then(({ DollarSign24 }) => ({
      default: DollarSign24,
    }))
  ),
  DotsAndroid16: React.lazy(() =>
    import('./DotsAndroid16').then(({ DotsAndroid16 }) => ({
      default: DotsAndroid16,
    }))
  ),
  DotsAndroid24: React.lazy(() =>
    import('./DotsAndroid24').then(({ DotsAndroid24 }) => ({
      default: DotsAndroid24,
    }))
  ),
  Download12: React.lazy(() =>
    import('./Download12').then(({ Download12 }) => ({
      default: Download12,
    }))
  ),
  Download16: React.lazy(() =>
    import('./Download16').then(({ Download16 }) => ({
      default: Download16,
    }))
  ),
  Download24: React.lazy(() =>
    import('./Download24').then(({ Download24 }) => ({
      default: Download24,
    }))
  ),
  Drag12: React.lazy(() =>
    import('./Drag12').then(({ Drag12 }) => ({
      default: Drag12,
    }))
  ),
  Drag16: React.lazy(() =>
    import('./Drag16').then(({ Drag16 }) => ({
      default: Drag16,
    }))
  ),
  Drag24: React.lazy(() =>
    import('./Drag24').then(({ Drag24 }) => ({
      default: Drag24,
    }))
  ),
  EconomicMoat24: React.lazy(() =>
    import('./EconomicMoat24').then(({ EconomicMoat24 }) => ({
      default: EconomicMoat24,
    }))
  ),
  Edit12: React.lazy(() =>
    import('./Edit12').then(({ Edit12 }) => ({
      default: Edit12,
    }))
  ),
  Edit16: React.lazy(() =>
    import('./Edit16').then(({ Edit16 }) => ({
      default: Edit16,
    }))
  ),
  Edit24: React.lazy(() =>
    import('./Edit24').then(({ Edit24 }) => ({
      default: Edit24,
    }))
  ),
  EditSurface24: React.lazy(() =>
    import('./EditSurface24').then(({ EditSurface24 }) => ({
      default: EditSurface24,
    }))
  ),
  EmailFilled16: React.lazy(() =>
    import('./EmailFilled16').then(({ EmailFilled16 }) => ({
      default: EmailFilled16,
    }))
  ),
  EmailFilled24: React.lazy(() =>
    import('./EmailFilled24').then(({ EmailFilled24 }) => ({
      default: EmailFilled24,
    }))
  ),
  EmailOutline24: React.lazy(() =>
    import('./EmailOutline24').then(({ EmailOutline24 }) => ({
      default: EmailOutline24,
    }))
  ),
  Entertainment24: React.lazy(() =>
    import('./Entertainment24').then(({ Entertainment24 }) => ({
      default: Entertainment24,
    }))
  ),
  Etf12: React.lazy(() =>
    import('./Etf12').then(({ Etf12 }) => ({
      default: Etf12,
    }))
  ),
  Etf24: React.lazy(() =>
    import('./Etf24').then(({ Etf24 }) => ({
      default: Etf24,
    }))
  ),
  Exclamation12: React.lazy(() =>
    import('./Exclamation12').then(({ Exclamation12 }) => ({
      default: Exclamation12,
    }))
  ),
  Exclamation16: React.lazy(() =>
    import('./Exclamation16').then(({ Exclamation16 }) => ({
      default: Exclamation16,
    }))
  ),
  Exclamation24: React.lazy(() =>
    import('./Exclamation24').then(({ Exclamation24 }) => ({
      default: Exclamation24,
    }))
  ),
  Expand16: React.lazy(() =>
    import('./Expand16').then(({ Expand16 }) => ({
      default: Expand16,
    }))
  ),
  Expand24: React.lazy(() =>
    import('./Expand24').then(({ Expand24 }) => ({
      default: Expand24,
    }))
  ),
  Eye16: React.lazy(() =>
    import('./Eye16').then(({ Eye16 }) => ({
      default: Eye16,
    }))
  ),
  Eye24: React.lazy(() =>
    import('./Eye24').then(({ Eye24 }) => ({
      default: Eye24,
    }))
  ),
  EyeClosed16: React.lazy(() =>
    import('./EyeClosed16').then(({ EyeClosed16 }) => ({
      default: EyeClosed16,
    }))
  ),
  EyeClosed24: React.lazy(() =>
    import('./EyeClosed24').then(({ EyeClosed24 }) => ({
      default: EyeClosed24,
    }))
  ),
  FaceIdAndroid16: React.lazy(() =>
    import('./FaceIdAndroid16').then(({ FaceIdAndroid16 }) => ({
      default: FaceIdAndroid16,
    }))
  ),
  FaceIdAndroid24: React.lazy(() =>
    import('./FaceIdAndroid24').then(({ FaceIdAndroid24 }) => ({
      default: FaceIdAndroid24,
    }))
  ),
  FaceIdIos16: React.lazy(() =>
    import('./FaceIdIos16').then(({ FaceIdIos16 }) => ({
      default: FaceIdIos16,
    }))
  ),
  FaceIdIos24: React.lazy(() =>
    import('./FaceIdIos24').then(({ FaceIdIos24 }) => ({
      default: FaceIdIos24,
    }))
  ),
  FairValue24: React.lazy(() =>
    import('./FairValue24').then(({ FairValue24 }) => ({
      default: FairValue24,
    }))
  ),
  Filter12: React.lazy(() =>
    import('./Filter12').then(({ Filter12 }) => ({
      default: Filter12,
    }))
  ),
  Filter16: React.lazy(() =>
    import('./Filter16').then(({ Filter16 }) => ({
      default: Filter16,
    }))
  ),
  Filter24: React.lazy(() =>
    import('./Filter24').then(({ Filter24 }) => ({
      default: Filter24,
    }))
  ),
  Finance12: React.lazy(() =>
    import('./Finance12').then(({ Finance12 }) => ({
      default: Finance12,
    }))
  ),
  Finance24: React.lazy(() =>
    import('./Finance24').then(({ Finance24 }) => ({
      default: Finance24,
    }))
  ),
  FlashOff24: React.lazy(() =>
    import('./FlashOff24').then(({ FlashOff24 }) => ({
      default: FlashOff24,
    }))
  ),
  FlashOn24: React.lazy(() =>
    import('./FlashOn24').then(({ FlashOn24 }) => ({
      default: FlashOn24,
    }))
  ),
  FlashlightOff24: React.lazy(() =>
    import('./FlashlightOff24').then(({ FlashlightOff24 }) => ({
      default: FlashlightOff24,
    }))
  ),
  FlashlightOn24: React.lazy(() =>
    import('./FlashlightOn24').then(({ FlashlightOn24 }) => ({
      default: FlashlightOn24,
    }))
  ),
  Folder16: React.lazy(() =>
    import('./Folder16').then(({ Folder16 }) => ({
      default: Folder16,
    }))
  ),
  Folder24: React.lazy(() =>
    import('./Folder24').then(({ Folder24 }) => ({
      default: Folder24,
    }))
  ),
  FullscreenEnter24: React.lazy(() =>
    import('./FullscreenEnter24').then(({ FullscreenEnter24 }) => ({
      default: FullscreenEnter24,
    }))
  ),
  FullscreenExit24: React.lazy(() =>
    import('./FullscreenExit24').then(({ FullscreenExit24 }) => ({
      default: FullscreenExit24,
    }))
  ),
  Gift12: React.lazy(() =>
    import('./Gift12').then(({ Gift12 }) => ({
      default: Gift12,
    }))
  ),
  Gift16: React.lazy(() =>
    import('./Gift16').then(({ Gift16 }) => ({
      default: Gift16,
    }))
  ),
  Gift24: React.lazy(() =>
    import('./Gift24').then(({ Gift24 }) => ({
      default: Gift24,
    }))
  ),
  Groceries24: React.lazy(() =>
    import('./Groceries24').then(({ Groceries24 }) => ({
      default: Groceries24,
    }))
  ),
  Healthcare12: React.lazy(() =>
    import('./Healthcare12').then(({ Healthcare12 }) => ({
      default: Healthcare12,
    }))
  ),
  Healthcare24: React.lazy(() =>
    import('./Healthcare24').then(({ Healthcare24 }) => ({
      default: Healthcare24,
    }))
  ),
  Home24: React.lazy(() =>
    import('./Home24').then(({ Home24 }) => ({
      default: Home24,
    }))
  ),
  Hospitality12: React.lazy(() =>
    import('./Hospitality12').then(({ Hospitality12 }) => ({
      default: Hospitality12,
    }))
  ),
  Hospitality24: React.lazy(() =>
    import('./Hospitality24').then(({ Hospitality24 }) => ({
      default: Hospitality24,
    }))
  ),
  Hourglass16: React.lazy(() =>
    import('./Hourglass16').then(({ Hourglass16 }) => ({
      default: Hourglass16,
    }))
  ),
  Hourglass24: React.lazy(() =>
    import('./Hourglass24').then(({ Hourglass24 }) => ({
      default: Hourglass24,
    }))
  ),
  IcloudRestore24: React.lazy(() =>
    import('./IcloudRestore24').then(({ IcloudRestore24 }) => ({
      default: IcloudRestore24,
    }))
  ),
  Image16: React.lazy(() =>
    import('./Image16').then(({ Image16 }) => ({
      default: Image16,
    }))
  ),
  Image24: React.lazy(() =>
    import('./Image24').then(({ Image24 }) => ({
      default: Image24,
    }))
  ),
  ImageFail16: React.lazy(() =>
    import('./ImageFail16').then(({ ImageFail16 }) => ({
      default: ImageFail16,
    }))
  ),
  ImageFail24: React.lazy(() =>
    import('./ImageFail24').then(({ ImageFail24 }) => ({
      default: ImageFail24,
    }))
  ),
  L2HeaderArrow24: React.lazy(() =>
    import('./L2HeaderArrow24').then(({ L2HeaderArrow24 }) => ({
      default: L2HeaderArrow24,
    }))
  ),
  Lightbulb16: React.lazy(() =>
    import('./Lightbulb16').then(({ Lightbulb16 }) => ({
      default: Lightbulb16,
    }))
  ),
  Lightbulb24: React.lazy(() =>
    import('./Lightbulb24').then(({ Lightbulb24 }) => ({
      default: Lightbulb24,
    }))
  ),
  Lightning12: React.lazy(() =>
    import('./Lightning12').then(({ Lightning12 }) => ({
      default: Lightning12,
    }))
  ),
  Lightning16: React.lazy(() =>
    import('./Lightning16').then(({ Lightning16 }) => ({
      default: Lightning16,
    }))
  ),
  Lightning24: React.lazy(() =>
    import('./Lightning24').then(({ Lightning24 }) => ({
      default: Lightning24,
    }))
  ),
  LightningOff16: React.lazy(() =>
    import('./LightningOff16').then(({ LightningOff16 }) => ({
      default: LightningOff16,
    }))
  ),
  LocationFill16: React.lazy(() =>
    import('./LocationFill16').then(({ LocationFill16 }) => ({
      default: LocationFill16,
    }))
  ),
  LocationFill24: React.lazy(() =>
    import('./LocationFill24').then(({ LocationFill24 }) => ({
      default: LocationFill24,
    }))
  ),
  LocationOutline24: React.lazy(() =>
    import('./LocationOutline24').then(({ LocationOutline24 }) => ({
      default: LocationOutline24,
    }))
  ),
  Manufacturing12: React.lazy(() =>
    import('./Manufacturing12').then(({ Manufacturing12 }) => ({
      default: Manufacturing12,
    }))
  ),
  Manufacturing24: React.lazy(() =>
    import('./Manufacturing24').then(({ Manufacturing24 }) => ({
      default: Manufacturing24,
    }))
  ),
  Maps24: React.lazy(() =>
    import('./Maps24').then(({ Maps24 }) => ({
      default: Maps24,
    }))
  ),
  Margin12: React.lazy(() =>
    import('./Margin12').then(({ Margin12 }) => ({
      default: Margin12,
    }))
  ),
  Margin16: React.lazy(() =>
    import('./Margin16').then(({ Margin16 }) => ({
      default: Margin16,
    }))
  ),
  Margin24: React.lazy(() =>
    import('./Margin24').then(({ Margin24 }) => ({
      default: Margin24,
    }))
  ),
  Maximum16: React.lazy(() =>
    import('./Maximum16').then(({ Maximum16 }) => ({
      default: Maximum16,
    }))
  ),
  Minimum16: React.lazy(() =>
    import('./Minimum16').then(({ Minimum16 }) => ({
      default: Minimum16,
    }))
  ),
  News16: React.lazy(() =>
    import('./News16').then(({ News16 }) => ({
      default: News16,
    }))
  ),
  News24: React.lazy(() =>
    import('./News24').then(({ News24 }) => ({
      default: News24,
    }))
  ),
  NoValue24: React.lazy(() =>
    import('./NoValue24').then(({ NoValue24 }) => ({
      default: NoValue24,
    }))
  ),
  NoValue32: React.lazy(() =>
    import('./NoValue32').then(({ NoValue32 }) => ({
      default: NoValue32,
    }))
  ),
  NotificationAdd16: React.lazy(() =>
    import('./NotificationAdd16').then(({ NotificationAdd16 }) => ({
      default: NotificationAdd16,
    }))
  ),
  NotificationAdd24: React.lazy(() =>
    import('./NotificationAdd24').then(({ NotificationAdd24 }) => ({
      default: NotificationAdd24,
    }))
  ),
  Online16: React.lazy(() =>
    import('./Online16').then(({ Online16 }) => ({
      default: Online16,
    }))
  ),
  Online24: React.lazy(() =>
    import('./Online24').then(({ Online24 }) => ({
      default: Online24,
    }))
  ),
  OptionsDown24: React.lazy(() =>
    import('./OptionsDown24').then(({ OptionsDown24 }) => ({
      default: OptionsDown24,
    }))
  ),
  OptionsFlat24: React.lazy(() =>
    import('./OptionsFlat24').then(({ OptionsFlat24 }) => ({
      default: OptionsFlat24,
    }))
  ),
  OptionsUp24: React.lazy(() =>
    import('./OptionsUp24').then(({ OptionsUp24 }) => ({
      default: OptionsUp24,
    }))
  ),
  OptionsVolatile24: React.lazy(() =>
    import('./OptionsVolatile24').then(({ OptionsVolatile24 }) => ({
      default: OptionsVolatile24,
    }))
  ),
  PauseHero40: React.lazy(() =>
    import('./PauseHero40').then(({ PauseHero40 }) => ({
      default: PauseHero40,
    }))
  ),
  PauseInline24: React.lazy(() =>
    import('./PauseInline24').then(({ PauseInline24 }) => ({
      default: PauseInline24,
    }))
  ),
  Paycheck24: React.lazy(() =>
    import('./Paycheck24').then(({ Paycheck24 }) => ({
      default: Paycheck24,
    }))
  ),
  Payment12: React.lazy(() =>
    import('./Payment12').then(({ Payment12 }) => ({
      default: Payment12,
    }))
  ),
  Payment16: React.lazy(() =>
    import('./Payment16').then(({ Payment16 }) => ({
      default: Payment16,
    }))
  ),
  Payment24: React.lazy(() =>
    import('./Payment24').then(({ Payment24 }) => ({
      default: Payment24,
    }))
  ),
  Payment32: React.lazy(() =>
    import('./Payment32').then(({ Payment32 }) => ({
      default: Payment32,
    }))
  ),
  PercentSign12: React.lazy(() =>
    import('./PercentSign12').then(({ PercentSign12 }) => ({
      default: PercentSign12,
    }))
  ),
  PercentSign16: React.lazy(() =>
    import('./PercentSign16').then(({ PercentSign16 }) => ({
      default: PercentSign16,
    }))
  ),
  PercentSign24: React.lazy(() =>
    import('./PercentSign24').then(({ PercentSign24 }) => ({
      default: PercentSign24,
    }))
  ),
  Phone16: React.lazy(() =>
    import('./Phone16').then(({ Phone16 }) => ({
      default: Phone16,
    }))
  ),
  Phone24: React.lazy(() =>
    import('./Phone24').then(({ Phone24 }) => ({
      default: Phone24,
    }))
  ),
  PhoneMissedCall16: React.lazy(() =>
    import('./PhoneMissedCall16').then(({ PhoneMissedCall16 }) => ({
      default: PhoneMissedCall16,
    }))
  ),
  PhoneWaiting16: React.lazy(() =>
    import('./PhoneWaiting16').then(({ PhoneWaiting16 }) => ({
      default: PhoneWaiting16,
    }))
  ),
  Pin16: React.lazy(() =>
    import('./Pin16').then(({ Pin16 }) => ({
      default: Pin16,
    }))
  ),
  Pin24: React.lazy(() =>
    import('./Pin24').then(({ Pin24 }) => ({
      default: Pin24,
    }))
  ),
  PlayHero40: React.lazy(() =>
    import('./PlayHero40').then(({ PlayHero40 }) => ({
      default: PlayHero40,
    }))
  ),
  Print24: React.lazy(() =>
    import('./Print24').then(({ Print24 }) => ({
      default: Print24,
    }))
  ),
  Qr16: React.lazy(() =>
    import('./Qr16').then(({ Qr16 }) => ({
      default: Qr16,
    }))
  ),
  Qr24: React.lazy(() =>
    import('./Qr24').then(({ Qr24 }) => ({
      default: Qr24,
    }))
  ),
  QrScan24: React.lazy(() =>
    import('./QrScan24').then(({ QrScan24 }) => ({
      default: QrScan24,
    }))
  ),
  Quantity16: React.lazy(() =>
    import('./Quantity16').then(({ Quantity16 }) => ({
      default: Quantity16,
    }))
  ),
  Quantity24: React.lazy(() =>
    import('./Quantity24').then(({ Quantity24 }) => ({
      default: Quantity24,
    }))
  ),
  RecurringHub24: React.lazy(() =>
    import('./RecurringHub24').then(({ RecurringHub24 }) => ({
      default: RecurringHub24,
    }))
  ),
  ReplayHero40: React.lazy(() =>
    import('./ReplayHero40').then(({ ReplayHero40 }) => ({
      default: ReplayHero40,
    }))
  ),
  Resend16: React.lazy(() =>
    import('./Resend16').then(({ Resend16 }) => ({
      default: Resend16,
    }))
  ),
  Resend24: React.lazy(() =>
    import('./Resend24').then(({ Resend24 }) => ({
      default: Resend24,
    }))
  ),
  Retirement12: React.lazy(() =>
    import('./Retirement12').then(({ Retirement12 }) => ({
      default: Retirement12,
    }))
  ),
  Retirement16: React.lazy(() =>
    import('./Retirement16').then(({ Retirement16 }) => ({
      default: Retirement16,
    }))
  ),
  Retirement24: React.lazy(() =>
    import('./Retirement24').then(({ Retirement24 }) => ({
      default: Retirement24,
    }))
  ),
  Retirement32: React.lazy(() =>
    import('./Retirement32').then(({ Retirement32 }) => ({
      default: Retirement32,
    }))
  ),
  RhwBrowserTab24: React.lazy(() =>
    import('./RhwBrowserTab24').then(({ RhwBrowserTab24 }) => ({
      default: RhwBrowserTab24,
    }))
  ),
  RhwChartTab24: React.lazy(() =>
    import('./RhwChartTab24').then(({ RhwChartTab24 }) => ({
      default: RhwChartTab24,
    }))
  ),
  RhwSearchTab24: React.lazy(() =>
    import('./RhwSearchTab24').then(({ RhwSearchTab24 }) => ({
      default: RhwSearchTab24,
    }))
  ),
  RiskAndUncertainty24: React.lazy(() =>
    import('./RiskAndUncertainty24').then(({ RiskAndUncertainty24 }) => ({
      default: RiskAndUncertainty24,
    }))
  ),
  RollingPosition12: React.lazy(() =>
    import('./RollingPosition12').then(({ RollingPosition12 }) => ({
      default: RollingPosition12,
    }))
  ),
  RollingPosition16: React.lazy(() =>
    import('./RollingPosition16').then(({ RollingPosition16 }) => ({
      default: RollingPosition16,
    }))
  ),
  RollingPosition24: React.lazy(() =>
    import('./RollingPosition24').then(({ RollingPosition24 }) => ({
      default: RollingPosition24,
    }))
  ),
  Scan16: React.lazy(() =>
    import('./Scan16').then(({ Scan16 }) => ({
      default: Scan16,
    }))
  ),
  Scan24: React.lazy(() =>
    import('./Scan24').then(({ Scan24 }) => ({
      default: Scan24,
    }))
  ),
  ShareAndroid16: React.lazy(() =>
    import('./ShareAndroid16').then(({ ShareAndroid16 }) => ({
      default: ShareAndroid16,
    }))
  ),
  ShareAndroid24: React.lazy(() =>
    import('./ShareAndroid24').then(({ ShareAndroid24 }) => ({
      default: ShareAndroid24,
    }))
  ),
  ShareIos16: React.lazy(() =>
    import('./ShareIos16').then(({ ShareIos16 }) => ({
      default: ShareIos16,
    }))
  ),
  ShareIos24: React.lazy(() =>
    import('./ShareIos24').then(({ ShareIos24 }) => ({
      default: ShareIos24,
    }))
  ),
  Smiley24: React.lazy(() =>
    import('./Smiley24').then(({ Smiley24 }) => ({
      default: Smiley24,
    }))
  ),
  SoundOff24: React.lazy(() =>
    import('./SoundOff24').then(({ SoundOff24 }) => ({
      default: SoundOff24,
    }))
  ),
  SoundOn24: React.lazy(() =>
    import('./SoundOn24').then(({ SoundOn24 }) => ({
      default: SoundOn24,
    }))
  ),
  SparkleBullet12: React.lazy(() =>
    import('./SparkleBullet12').then(({ SparkleBullet12 }) => ({
      default: SparkleBullet12,
    }))
  ),
  SparkleBullet16: React.lazy(() =>
    import('./SparkleBullet16').then(({ SparkleBullet16 }) => ({
      default: SparkleBullet16,
    }))
  ),
  SparkleBullet24: React.lazy(() =>
    import('./SparkleBullet24').then(({ SparkleBullet24 }) => ({
      default: SparkleBullet24,
    }))
  ),
  StarOutline16: React.lazy(() =>
    import('./StarOutline16').then(({ StarOutline16 }) => ({
      default: StarOutline16,
    }))
  ),
  StarOutline24: React.lazy(() =>
    import('./StarOutline24').then(({ StarOutline24 }) => ({
      default: StarOutline24,
    }))
  ),
  Stewardship24: React.lazy(() =>
    import('./Stewardship24').then(({ Stewardship24 }) => ({
      default: Stewardship24,
    }))
  ),
  StockDown12: React.lazy(() =>
    import('./StockDown12').then(({ StockDown12 }) => ({
      default: StockDown12,
    }))
  ),
  StockDown16: React.lazy(() =>
    import('./StockDown16').then(({ StockDown16 }) => ({
      default: StockDown16,
    }))
  ),
  StockDown24: React.lazy(() =>
    import('./StockDown24').then(({ StockDown24 }) => ({
      default: StockDown24,
    }))
  ),
  StockUp12: React.lazy(() =>
    import('./StockUp12').then(({ StockUp12 }) => ({
      default: StockUp12,
    }))
  ),
  StockUp16: React.lazy(() =>
    import('./StockUp16').then(({ StockUp16 }) => ({
      default: StockUp16,
    }))
  ),
  StockUp24: React.lazy(() =>
    import('./StockUp24').then(({ StockUp24 }) => ({
      default: StockUp24,
    }))
  ),
  Stopwatch16: React.lazy(() =>
    import('./Stopwatch16').then(({ Stopwatch16 }) => ({
      default: Stopwatch16,
    }))
  ),
  Stopwatch24: React.lazy(() =>
    import('./Stopwatch24').then(({ Stopwatch24 }) => ({
      default: Stopwatch24,
    }))
  ),
  Stopwatch32: React.lazy(() =>
    import('./Stopwatch32').then(({ Stopwatch32 }) => ({
      default: Stopwatch32,
    }))
  ),
  StrategyOutlook24: React.lazy(() =>
    import('./StrategyOutlook24').then(({ StrategyOutlook24 }) => ({
      default: StrategyOutlook24,
    }))
  ),
  SwipeDown16: React.lazy(() =>
    import('./SwipeDown16').then(({ SwipeDown16 }) => ({
      default: SwipeDown16,
    }))
  ),
  SwipeDown24: React.lazy(() =>
    import('./SwipeDown24').then(({ SwipeDown24 }) => ({
      default: SwipeDown24,
    }))
  ),
  SwipeUp16: React.lazy(() =>
    import('./SwipeUp16').then(({ SwipeUp16 }) => ({
      default: SwipeUp16,
    }))
  ),
  SwipeUp24: React.lazy(() =>
    import('./SwipeUp24').then(({ SwipeUp24 }) => ({
      default: SwipeUp24,
    }))
  ),
  Switch16: React.lazy(() =>
    import('./Switch16').then(({ Switch16 }) => ({
      default: Switch16,
    }))
  ),
  Switch24: React.lazy(() =>
    import('./Switch24').then(({ Switch24 }) => ({
      default: Switch24,
    }))
  ),
  TabAccount32: React.lazy(() =>
    import('./TabAccount32').then(({ TabAccount32 }) => ({
      default: TabAccount32,
    }))
  ),
  TabContent32: React.lazy(() =>
    import('./TabContent32').then(({ TabContent32 }) => ({
      default: TabContent32,
    }))
  ),
  TabCrypto32: React.lazy(() =>
    import('./TabCrypto32').then(({ TabCrypto32 }) => ({
      default: TabCrypto32,
    }))
  ),
  TabCryptoC32: React.lazy(() =>
    import('./TabCryptoC32').then(({ TabCryptoC32 }) => ({
      default: TabCryptoC32,
    }))
  ),
  TabInvest32: React.lazy(() =>
    import('./TabInvest32').then(({ TabInvest32 }) => ({
      default: TabInvest32,
    }))
  ),
  TabMessages32: React.lazy(() =>
    import('./TabMessages32').then(({ TabMessages32 }) => ({
      default: TabMessages32,
    }))
  ),
  TabMoney32: React.lazy(() =>
    import('./TabMoney32').then(({ TabMoney32 }) => ({
      default: TabMoney32,
    }))
  ),
  TabRetirement32: React.lazy(() =>
    import('./TabRetirement32').then(({ TabRetirement32 }) => ({
      default: TabRetirement32,
    }))
  ),
  TabSearch32: React.lazy(() =>
    import('./TabSearch32').then(({ TabSearch32 }) => ({
      default: TabSearch32,
    }))
  ),
  Tag16: React.lazy(() =>
    import('./Tag16').then(({ Tag16 }) => ({
      default: Tag16,
    }))
  ),
  Tag24: React.lazy(() =>
    import('./Tag24').then(({ Tag24 }) => ({
      default: Tag24,
    }))
  ),
  Technology12: React.lazy(() =>
    import('./Technology12').then(({ Technology12 }) => ({
      default: Technology12,
    }))
  ),
  Technology24: React.lazy(() =>
    import('./Technology24').then(({ Technology24 }) => ({
      default: Technology24,
    }))
  ),
  Thumbprint16: React.lazy(() =>
    import('./Thumbprint16').then(({ Thumbprint16 }) => ({
      default: Thumbprint16,
    }))
  ),
  Thumbprint24: React.lazy(() =>
    import('./Thumbprint24').then(({ Thumbprint24 }) => ({
      default: Thumbprint24,
    }))
  ),
  Ticket16: React.lazy(() =>
    import('./Ticket16').then(({ Ticket16 }) => ({
      default: Ticket16,
    }))
  ),
  Ticket24: React.lazy(() =>
    import('./Ticket24').then(({ Ticket24 }) => ({
      default: Ticket24,
    }))
  ),
  TouchIdAndroid16: React.lazy(() =>
    import('./TouchIdAndroid16').then(({ TouchIdAndroid16 }) => ({
      default: TouchIdAndroid16,
    }))
  ),
  TouchIdAndroid24: React.lazy(() =>
    import('./TouchIdAndroid24').then(({ TouchIdAndroid24 }) => ({
      default: TouchIdAndroid24,
    }))
  ),
  Transport24: React.lazy(() =>
    import('./Transport24').then(({ Transport24 }) => ({
      default: Transport24,
    }))
  ),
  Tuner16: React.lazy(() =>
    import('./Tuner16').then(({ Tuner16 }) => ({
      default: Tuner16,
    }))
  ),
  Tuner24: React.lazy(() =>
    import('./Tuner24').then(({ Tuner24 }) => ({
      default: Tuner24,
    }))
  ),
  Unlock12: React.lazy(() =>
    import('./Unlock12').then(({ Unlock12 }) => ({
      default: Unlock12,
    }))
  ),
  Unlock16: React.lazy(() =>
    import('./Unlock16').then(({ Unlock16 }) => ({
      default: Unlock16,
    }))
  ),
  Unlock24: React.lazy(() =>
    import('./Unlock24').then(({ Unlock24 }) => ({
      default: Unlock24,
    }))
  ),
  Upload24: React.lazy(() =>
    import('./Upload24').then(({ Upload24 }) => ({
      default: Upload24,
    }))
  ),
  VideoFastForward24: React.lazy(() =>
    import('./VideoFastForward24').then(({ VideoFastForward24 }) => ({
      default: VideoFastForward24,
    }))
  ),
  VideoReplay24: React.lazy(() =>
    import('./VideoReplay24').then(({ VideoReplay24 }) => ({
      default: VideoReplay24,
    }))
  ),
  VideoRewind1532: React.lazy(() =>
    import('./VideoRewind1532').then(({ VideoRewind1532 }) => ({
      default: VideoRewind1532,
    }))
  ),
  VideoRewind24: React.lazy(() =>
    import('./VideoRewind24').then(({ VideoRewind24 }) => ({
      default: VideoRewind24,
    }))
  ),
  VideoSkip1532: React.lazy(() =>
    import('./VideoSkip1532').then(({ VideoSkip1532 }) => ({
      default: VideoSkip1532,
    }))
  ),
  Wallet24: React.lazy(() =>
    import('./Wallet24').then(({ Wallet24 }) => ({
      default: Wallet24,
    }))
  ),
  Wallet32: React.lazy(() =>
    import('./Wallet32').then(({ Wallet32 }) => ({
      default: Wallet32,
    }))
  ),
  Walletconnect16: React.lazy(() =>
    import('./Walletconnect16').then(({ Walletconnect16 }) => ({
      default: Walletconnect16,
    }))
  ),
  Walletconnect24: React.lazy(() =>
    import('./Walletconnect24').then(({ Walletconnect24 }) => ({
      default: Walletconnect24,
    }))
  ),
  WcScan24: React.lazy(() =>
    import('./WcScan24').then(({ WcScan24 }) => ({
      default: WcScan24,
    }))
  ),
  Withdraw24: React.lazy(() =>
    import('./Withdraw24').then(({ Withdraw24 }) => ({
      default: Withdraw24,
    }))
  ),
  ZoomIn24: React.lazy(() =>
    import('./ZoomIn24').then(({ ZoomIn24 }) => ({
      default: ZoomIn24,
    }))
  ),
  ZoomOut24: React.lazy(() =>
    import('./ZoomOut24').then(({ ZoomOut24 }) => ({
      default: ZoomOut24,
    }))
  ),
}
